export const surveys = {
  loading: {
    isLoadingSurveys: false,
    isLoadingSurvey: false,
  },
  strings: {
    title: undefined,
    subtitle: undefined,
    'title.survey.create': 'Questionnaire',
    'title.surveys.list': 'Questionnaires',
    // <PARTIES>
    'surveys.controls.info.label': 'survey(s) found',
    'surveys.grid.cell.actions.btn.view.label': 'View',
    'surveys.grid.cell.actions.btn.edit.label': 'Edit',
    'surveys.grid.cell.actions.btn.cancel.label': 'Cancel',
    'surveys.grid.cell.actions.btn.modify.label': 'Modify',

    'surveys.grid.column.id.label': 'Id',
    'surveys.grid.column.surveyName.label': 'Subscriber',
    'surveys.grid.column.status.label': 'Status',
    'surveys.grid.column.surveyId.label': 'Party',
    'surveys.grid.column.createdOn.label': 'Creation Date',
    'surveys.grid.column.date.label': 'Effective Date',
    'surveys.grid.column.SurveyName.label': 'Survey',

    'surveys.grid.column.actions.label': 'Actions',

    'surveys.filter.label': 'Filtres',
    // </PARTIES>
  },
};
